import { NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { AppContext } from "../../../../Common/AppContext";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { BaseActions } from "../Actions/BaseActions";
import { GameData } from "../Datas/GameData";
import { BetManager } from "../../../Managers/BetManager";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { Languages } from "../../../Utils/Languages";
import { DataManager } from "../../../Managers/DataManager";
import { GameManager } from "../../../Managers/GameManager";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { FreeRoundBonusIcon } from "../Dialogs/FreeRoundBonusIcon";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { DialogType } from "../Dialogs/FreeRoundBonusDialog";

export class BuyFeature {
    //******************************************************************************************************************
    //  SETTINGS
    //******************************************************************************************************************

    private static BuyFeatureConfirmEnabled: boolean = true;

    private static MaxBuyFeatureBetLimit: number = -1;

    private static BetMultiplier: number = 100;

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static initialized: boolean = false;

    private static currentBetIndex: number = -1;

    private static opened: boolean = false;

    //root
    private static root: HTMLElement;

    //overlay
    private static overlay: HTMLElement;

    //dialogs
    private static dialog: HTMLElement;

    private static confirmDialog: HTMLElement;

    //buttons
    private static buyBtn: HTMLElement;

    private static betMinusBtn: HTMLElement;

    private static betPlusBtn: HTMLElement;

    private static declineBtn: HTMLElement;

    private static closeBtn: HTMLElement;

    private static confirmCloseBtn: HTMLElement;

    //icon
    private static icon: HTMLElement;

    //******************************************************************************************************************
    //  INITIALIZE
    //******************************************************************************************************************

    public static initialize(): void {
        BuyFeature.config();

        if (
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.BuyFeatureEnabled &&
            !BuyFeature.isMaxBuyFeatureLimit(0)
        ) {
            //setup confirm dialog
            BuyFeature.BuyFeatureConfirmEnabled = AppContext.gameConfiguration.BuyFeatureConfirmEnabled;

            //root
            BuyFeature.root = document.getElementById("buyFeature");

            //overlay
            BuyFeature.overlay = document.getElementById("buyFeatureOverlay");

            //dialogs
            BuyFeature.dialog = document.getElementById("buyFeatureDialog");
            BuyFeature.confirmDialog = document.getElementById("buyFeatureConfirmDialog");

            //buttons
            BuyFeature.buyBtn = document.getElementById("buyFeatureBuyButton");
            BuyFeature.betMinusBtn = document.getElementById("buyFeatureBetMinus");
            BuyFeature.betPlusBtn = document.getElementById("buyFeatureBetPlus");
            BuyFeature.declineBtn = document.getElementById("buyFeatureDeclineButton");
            BuyFeature.closeBtn = document.getElementById("buyFeatureCloseButton");
            BuyFeature.confirmCloseBtn = document.getElementById("buyFeatureConfirmCloseButton");

            //icon
            BuyFeature.icon = document.getElementById("buyFeatureIcon");

            BuyFeature.bindActions();
            BuyFeature.initialized = true;
        } else {
            BuyFeature.clean();
        }
    }

    //******************************************************************************************************************
    //  PRIVATE HANDLERS
    //******************************************************************************************************************

    private static config(): void {
        if (GameManager.baseResponse.initData != null && GameManager.baseResponse.initData["customData"] != null) {
            if (GameManager.baseResponse.initData["customData"]["buyFeatureConversion"]) {
                BuyFeature.BetMultiplier = GameManager.baseResponse.initData["customData"]["buyFeatureConversion"];
            }

            if (GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"]) {
                BuyFeature.MaxBuyFeatureBetLimit =
                    GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"];
            }
        }
    }

    private static bindActions(): void {
        if (BuyFeature.closeBtn != null) {
            BuyFeature.closeBtn.onclick = BuyFeature.onCloseDialog.bind(this);
        }

        if (BuyFeature.declineBtn != null) {
            BuyFeature.declineBtn.onclick = BuyFeature.onCloseConfirmDialog.bind(this);
        }

        if (BuyFeature.confirmCloseBtn != null) {
            BuyFeature.confirmCloseBtn.onclick = BuyFeature.onCloseConfirmDialog.bind(this);
        }

        if (BuyFeature.buyBtn != null) {
            BuyFeature.buyBtn.onclick = BuyFeature.onOpenConfirmDialog.bind(this);
        }

        if (BuyFeature.betMinusBtn != null) {
            BuyFeature.betMinusBtn.onclick = BuyFeature.onBetChange.bind(this, true);
        }

        if (BuyFeature.betPlusBtn != null) {
            BuyFeature.betPlusBtn.onclick = BuyFeature.onBetChange.bind(this, false);
        }

        if (BuyFeature.root != null) {
            BuyFeature.root.addEventListener("webkitAnimationEnd", BuyFeature.removeIntroClass);
            BuyFeature.root.addEventListener("animationend", BuyFeature.removeIntroClass);
        }

        /* Temporary fix for closing BF dialog when other dialogs open.
         * */
        Platforms.Platforms.eventEmitter.on(Platforms.Platforms.PlatformCloseMenu, () => {
            BuyFeature.onCloseDialog(true);
        });
    }

    private static clean(): void {
        const buyFeature = document.getElementById("buyFeature");
        if (buyFeature != null && buyFeature.parentElement != null) {
            buyFeature.parentElement.removeChild(buyFeature);
        }

        const elements = document.getElementsByClassName("helpBuyFeature");
        if (elements != null && elements.length > 0) {
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }
        }
    }

    private static closeConfirmDialog(): void {
        if (BuyFeature.confirmDialog != null) {
            BuyFeature.confirmDialog.classList.add("_hidden");
        }

        if (BuyFeature.dialog != null) {
            BuyFeature.dialog.classList.remove("_hidden");
        }
    }

    private static openConfirmDialog(): void {
        if (!BuyFeature.BuyFeatureConfirmEnabled) {
            HtmlController.dispatchAction(BaseActions.ActionBuyFeature);
            return;
        }

        if (BuyFeature.confirmDialog != null) {
            BuyFeature.confirmDialog.classList.remove("_hidden");
        }

        if (BuyFeature.dialog != null) {
            BuyFeature.dialog.classList.add("_hidden");
        }
    }

    private static closeDialog(): void {
        if (BuyFeature.overlay != null) {
            BuyFeature.overlay.classList.add("_hidden");
        }
        if (BuyFeature.dialog != null) {
            BuyFeature.dialog.classList.add("_hidden");
        }

        Platforms.Platforms.dialogOpened("buyFeature", false);
        BuyFeature.opened = false;

        ModuleManager.enableGamble();
    }

    private static openDialog(): void {
        BuyFeature.updateBet();
        BuyFeature.updateData();

        if (BuyFeature.overlay != null) {
            BuyFeature.overlay.classList.remove("_hidden");
        }
        if (BuyFeature.dialog != null) {
            BuyFeature.dialog.classList.remove("_hidden");
        }

        Platforms.Platforms.dialogOpened("buyFeature", true);
        BuyFeature.opened = true;

        FreeRoundBonusIcon.disableActiveIcon();

        ModuleManager.disableGamble();
    }

    private static updateBet(): void {
        //set current betIndex
        BuyFeature.currentBetIndex = BetManager.TotalBets.indexOf(BetManager.Bet);

        //find first allowed bet
        while (BuyFeature.isMaxBuyFeatureLimit(BuyFeature.currentBetIndex) && BuyFeature.currentBetIndex > -1) {
            BuyFeature.currentBetIndex--;
        }
    }

    private static updateData(): void {
        let bet = BetManager.TotalBets[this.currentBetIndex].toString();
        HtmlController.updateDataElement(
            GameData.DataBuyFeatureCost,
            NumberUtils.multiply(bet, BuyFeature.BetMultiplier),
        );
        HtmlController.updateDataElement(
            GameData.DataBuyFeatureCostWithCurrency,
            Languages.formatText(Languages.FormatMoney, NumberUtils.multiply(bet, BuyFeature.BetMultiplier)) +
                "\u00A0" +
                DataManager.getDataById(GameData.DataCurrency),
        );
        HtmlController.updateDataElement(GameData.DataBuyFeatureBet, bet);
        BuyFeature.checkBetButtons();
    }

    private static checkBetButtons(): void {
        BuyFeature.betMinusBtn.classList.remove("_disabled");
        BuyFeature.betPlusBtn.classList.remove("_disabled");

        if (BuyFeature.currentBetIndex == 0) {
            BuyFeature.betMinusBtn.classList.add("_disabled");
        }

        if (
            BuyFeature.currentBetIndex == BetManager.TotalBets.length - 1 ||
            BuyFeature.isMaxBuyFeatureLimit(this.currentBetIndex + 1)
        ) {
            BuyFeature.betPlusBtn.classList.add("_disabled");
        }
    }

    private static isMaxBuyFeatureLimit(betIndex: number): boolean {
        if (BuyFeature.MaxBuyFeatureBetLimit > -1 && betIndex < BetManager.TotalBets.length) {
            const nextBet = BetManager.TotalBets[betIndex];
            const totalBet = parseFloat(NumberUtils.multiply(nextBet, BuyFeature.BetMultiplier));

            if (totalBet > BuyFeature.MaxBuyFeatureBetLimit) {
                return true;
            }
        }

        return false;
    }

    private static hasFeatureModuleActive(): boolean {
        const featureModules = ["freespinsActive", "bonusActive", "pickActive"];
        for (let i = 0; i < featureModules.length; i++) {
            if (ModuleManager[featureModules[i]] && ModuleManager[featureModules[i]]()) {
                return true;
            }
        }

        return false;
    }

    private static removeIntroClass(): void {
        if (BuyFeature.root != null) {
            BuyFeature.root.classList.remove("buyFeatureIntro");
        }
    }

    private static addIntroClass(): void {
        if (BuyFeature.root != null) {
            BuyFeature.root.classList.add("buyFeatureIntro");
        }
    }

    //******************************************************************************************************************
    //  BINDINGS
    //******************************************************************************************************************

    private static onCloseDialog(silent: boolean = false): void {
        if (!BuyFeature.opened) {
            return;
        }
        if (!silent) {
            PlayList.play("SND_Click");
        }
        BuyFeature.closeConfirmDialog();
        BuyFeature.closeDialog();
        ModuleManager.restoreGameRound(Communication.Game.GameModules.Base);
    }

    private static onCloseConfirmDialog(): void {
        PlayList.play("SND_Click");
        BuyFeature.closeConfirmDialog();
    }

    private static onOpenDialog(): void {
        PlayList.play("SND_Click");
        BuyFeature.openDialog();
    }

    private static onToggleDialog(): void {
        if (BuyFeature.opened) {
            BuyFeature.onCloseDialog();
        } else {
            BuyFeature.onOpenDialog();
        }
    }

    private static onOpenConfirmDialog(): void {
        PlayList.play("SND_Click");
        BuyFeature.openConfirmDialog();
    }

    private static onBetChange(decrease: boolean): void {
        PlayList.play("SND_Click");
        if (decrease && BuyFeature.currentBetIndex > 0) {
            BuyFeature.currentBetIndex--;
        } else if (!decrease && BuyFeature.currentBetIndex < BetManager.TotalBets.length - 1) {
            BuyFeature.currentBetIndex++;
        }

        BuyFeature.updateData();
    }

    //******************************************************************************************************************
    //  PUBLIC HANDLERS
    //******************************************************************************************************************

    public static spin(): void {
        BuyFeature.closeConfirmDialog();
        BuyFeature.closeDialog();
    }

    public static open(): void {
        BuyFeature.onToggleDialog();
    }

    public static getBuyfeatureOriginalBet(): number {
        return BetManager.TotalBets[BuyFeature.currentBetIndex];
    }

    public static getBuyFeatureBet(): Communication.Game.SpinBet {
        let buyFeatureBet: number;
        if (FreeRoundBonus.status !== "active") {
            buyFeatureBet = parseFloat(
                NumberUtils.multiply(BetManager.TotalBets[BuyFeature.currentBetIndex], BuyFeature.BetMultiplier),
            );
        } else {
            buyFeatureBet = parseFloat(NumberUtils.multiply(BetManager.Bet, BuyFeature.BetMultiplier));
        }
        return new Communication.Game.SpinBet(Communication.Game.BetType.Total, null, null, null, buyFeatureBet);
    }

    public static getBuyFeatureName(): string {
        if (FreeRoundBonus.dialogType !== null && FreeRoundBonus.dialogType == DialogType.FFR && FreeRoundBonus.featureName !== null) {
            return FreeRoundBonus.featureName;
        }
        return "HoldAndWin";
    }

    public static hideBuyFeatureIcon(): void {
        if (BuyFeature.icon != null) {
            BuyFeature.icon.classList.add("_hidden");
        }

        if (BuyFeature.opened) {
            BuyFeature.closeConfirmDialog();
            BuyFeature.closeDialog();
        }
    }

    public static showBuyFeatureIcon(init: boolean = false): void {
        if (this.hasFeatureModuleActive()) {
            return;
        }

        if (BuyFeature.icon != null) {
            BuyFeature.icon.classList.remove("_hidden");
        }

        if (!DataManager.Autoplay) {
            ModuleManager.enableBuyFeature();
        }

        if (init && BuyFeature.icon != null && !BuyFeature.icon.classList.contains("_disabled")) {
            BuyFeature.addIntroClass();
        }
    }

    public static buyFeatureBtnEnabled(wasCalculated: boolean): boolean {
        return (
            AppContext.gameConfiguration.BuyFeatureEnabled &&
            !this.hasFeatureModuleActive() &&
            (DataManager.GameRoundClosed ||
                (!DataManager.GameRoundClosed && !AppContext.gameConfiguration.CollectOnUnCalculatedWin) ||
                (!DataManager.GameRoundClosed &&
                    AppContext.gameConfiguration.CollectOnUnCalculatedWin &&
                    wasCalculated))
        );
    }

    public static disable(): void {
        if (BuyFeature.root != null) {
            BuyFeature.root.classList.add("_disabled");
        }

        BuyFeature.hideBuyFeatureIcon();
    }

    public static restore(): void {
        if (BuyFeature.root != null) {
            BuyFeature.root.classList.remove("_disabled");
        }

        BuyFeature.showBuyFeatureIcon();
    }

    public static isOpen(): boolean {
        return BuyFeature.opened;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/BuyFeature/BuyFeature.ts
 **/